<template>
    <v-card class="mx-auto">
        <v-list-item class="v-list-item-therapist" four-line>
            <v-list-item-content class="v-list-item-therapist-content">
                <v-list-item-title class="headline mb-1">
                    <img width="75" height="75" v-show="!!therapist.mediaLink" :src="therapist.mediaLink" />
                    <div>{{therapist.therapeutName + " - " + therapist.location}}</div>
                </v-list-item-title>
            </v-list-item-content>

            <v-list-item-action tile size="80" class="v-list-item-therapist-content">
                <v-list-item>
                    <v-card-actions>
                        <v-btn v-if="timeSlotText != ''"
                               :color="therapeutSelectBackgroundColor"
                               large
                               @click="onClick">
                            Kies
                        </v-btn>
                        <v-btn v-else
                               :color="therapeutSelectBackgroundColor"
                                large>
                            Niet Beschikbaar
                        </v-btn>
                        <p></p>
                    </v-card-actions>
                </v-list-item>
                <v-list-item>
                    <p class="font-italic">{{timeSlotText}}</p>
                </v-list-item>
            </v-list-item-action>
        </v-list-item>
    </v-card>
</template>
<style scoped>
    .v-list-item__title {
        display: flex;
        align-items: center;
    }
    .v-list-item__title > img {
        margin-right: 15px;
    }
    .v-list-item__content {
        min-width:65%;
    }
    .v-list-item-therapist-content {
        white-space: normal;
    }
    .v-list-item__action {
        float: right;
    }

    @media only screen and (max-width: 500px) {
        .v-list-item-therapist {
            display:inline-block;
        }
    }
</style>
<script>
    /* eslint-disable */
    import { mapState } from "vuex";
    import * as moment from "moment";

    export default {
        props: {
            therapist: Object,
        },
        data: function () {
            return {
                therapeutSelectBackgroundColor: null,
                timeSlotText: null
            };
        },
        mounted: function () {
            this.updateTimeSlotText();
        },
        computed: {
            ...mapState("app", ["status", "siteInfo"]),
        },
        methods: {
            onClick(option) {
                this.$emit('fromTherapistItem', this.therapist.id);
            },
            updateTimeSlotText() {
                if (moment(this.therapist.firstSlot).format('DD-MM-yyyy') == '01-01-0001') {
                    this.therapeutSelectBackgroundColor = this.siteInfo.colorInfo.therapeutUnavailableBackgroundColor;
                    this.timeSlotText = "";
                } else {
                    this.therapeutSelectBackgroundColor = this.siteInfo.colorInfo.therapeutSelectBackgroundColor;
                    this.timeSlotText = "Eerste optie: " + moment(this.therapist.firstSlot).format('DD-MM-yyyy') + " om " + moment(this.therapist.firstSlot).format('HH:mm');
                }
            }
        },
        watch: {
            therapist: function () {
                this.updateTimeSlotText();
            }
        }
    }
</script>